/**
 *  @class
 *  @function ViewProducts
 */
if (!customElements.get('view-products')) {
  class ViewProducts extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.drawer = document.querySelector(this.dataset.target);
      this.addEventListener('click', this.setupEventListener.bind(this));
      this.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ENTER' || event.code.toUpperCase() === 'SPACE' || event.keyCode == 13) {
          this.setupEventListener();
        }
      });
    }
    setupEventListener() {
      document.body.classList.add('open-cc');
      this.drawer.removeAttribute('inert');
      this.drawer.classList.add('active');
      trapFocus(this.drawer);
    }
  }
  customElements.define('view-products', ViewProducts);
}
